import Modal from './modal-TEMPLATE_VERSION'

export default Modal
